import React, { useId } from 'react';
import styled from 'styled-components';
import { CrudStyles } from './Crud';
import {
    ADDRESS_NAME_MAX_LENGTH,
    ADDRESS_NAME_TOOLTIP,
    ADDRESS_PLACE_COLUMN_TOOLTIP,
} from '../../utils/addressName';

const { FormGroup, Input } = CrudStyles;

const LabelRow = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

const InfoHint = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: ${({ theme }) => theme?.colors?.gray?.[300] || '#d1d5db'};
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    cursor: help;
    flex-shrink: 0;
`;

/**
 * Apelido opcional do endereço.
 * O `name` do input continua `name` para os formulários de endereço;
 * telas que já usam `name` para outra coisa podem sobrescrever.
 */
export default function AddressNameField({
    id,
    name = 'name',
    value = '',
    onChange,
    error,
    disabled = false,
    showLabel = true,
}) {
    const generatedId = useId();
    const inputId = id || generatedId;

    return (
        <FormGroup>
            {showLabel && (
                <LabelRow htmlFor={inputId}>
                    Nome
                    <InfoHint
                        type="button"
                        title={ADDRESS_NAME_TOOLTIP}
                        aria-label={ADDRESS_NAME_TOOLTIP}
                    >
                        ?
                    </InfoHint>
                </LabelRow>
            )}
            <Input
                id={inputId}
                name={name}
                value={value ?? ''}
                onChange={onChange}
                $hasError={!!error}
                disabled={disabled}
                maxLength={ADDRESS_NAME_MAX_LENGTH}
                placeholder="Ex.: Matriz, Galpão 2"
                autoComplete="off"
            />
            {error && <span className="error">{error}</span>}
        </FormGroup>
    );
}

export function AddressPlaceColumnHeader() {
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            Nome/Logradouro
            <InfoHint
                type="button"
                title={ADDRESS_PLACE_COLUMN_TOOLTIP}
                aria-label={ADDRESS_PLACE_COLUMN_TOOLTIP}
                onClick={(event) => event.stopPropagation()}
            >
                ?
            </InfoHint>
        </span>
    );
}
